import React, {useEffect} from "react";
import {Route, Routes} from "react-router-dom";

import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

import Elapsed from "../views/profiling/Elapsed.js";
import Simulator from "../views/data/Simulator";
import {getCookie, removeCookie, TOKEN_KEY} from "../cookie/CookieProvider";
import {jwtDecode} from "jwt-decode";
import Monitor from "../views/message/monitor";

export default function MainDashboard() {

  useEffect(() => {
    if (((getCookie(TOKEN_KEY)) === undefined) || (jwtDecode(getCookie(TOKEN_KEY))['exp'] < Date.now() / 1000)) {
      alert("세션 정보가 사라졌습니다. 다시 로그인해주세요.")
      removeCookie(TOKEN_KEY)
      window.location.href = "/auth/login"
    }
  }, []);


  return (
    <>
      <Sidebar/>
      <div className="relative md:ml-64 bg-blueGray-400">
        <HeaderStats/>

        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div className="rounded overflow-hidden shadow-lg">
              <Routes>
                <Route path="*" element={<Simulator/>}/>
                <Route path="/data/simulator" element={<Simulator/>}/>
                <Route path="/message/monitor" element={<Monitor/>}/>
                <Route path="/profiling/elapsed" element={<Elapsed/>}/>
              </Routes>
            </div>
            <FooterAdmin/>
          </div>
        </div>
      </div>
    </>
  );
}
